module.exports = __webpack_public_path__ + "static/media/pseudochorthippus_parallelus_006_Tag_APA.08b525b4.png";